import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import TableRow from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import Image from "../Common/Image";
/**
 * @deprecated use material-react-table
 * @param param0
 * @returns
 */
function DataTableRowDetails({ row, columnsLength, }) {
    if (!row.details) {
        return _jsx(Fragment, {});
    }
    return (_jsxs(TableRow, { className: "DataTableRow", children: [_jsx(TableCell, { colSpan: 3, children: row.details.image ? (_jsx(Image, { src: row.details.image, alt: row.details.image })) : null }), _jsx(TableCell, { colSpan: columnsLength - 3, children: _jsx("table", { children: _jsx("tbody", { children: Object.keys(row.details)
                            .filter((key) => key !== "image")
                            .map((key) => {
                            var _a;
                            return (_jsxs("tr", { children: [_jsxs("th", { children: [key, ":"] }), _jsx("td", { children: (_a = row.details) === null || _a === void 0 ? void 0 : _a[key] })] }, key));
                        }) }) }) })] }));
}
export default DataTableRowDetails;
//# sourceMappingURL=DataTableRowDetails.js.map